import React from "react";
import { useTranslation } from "react-i18next";
import Spinner from "@/components/ui/spinner";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";

interface Props {
  className?: string;
}

/**
 * "Analyzing transcript" indication shown on a meeting activity while its summary
 * and autofill fields are still being generated. Rendered wherever the activity
 * timeline appears, so a user does not mistake the in-progress state for missing data.
 */
const TranscriptProcessingIndicator: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <output
      className={cn(
        "flex gap-2 items-start p-2 rounded-lg bg-white-4",
        className
      )}
    >
      <Spinner size="sm" className="mt-0.5" />
      <div className="flex flex-col gap-0.5 min-w-0">
        <Text variant="label">
          {t("activities.transcript.processingTitle")}
        </Text>
        <Text variant="bodySecondary">
          {t("activities.transcript.processingSubtext")}
        </Text>
      </div>
    </output>
  );
};

export default TranscriptProcessingIndicator;
